<template>
  <div class="energy-meter">
    <svg viewBox="0 0 500 500" class="c">
      <circle
        v-for="key in calorieTypeKeys"
        :key="key"
        :class="`${key <= dailyCalorieType ? '-active' : ''}`"
        cx="50%"
        cy="50%"
        :r="`${key * 5 - 4}%`"
      />
      <!--      <circle cx="50%" cy="50%" r="1%" class="-active"></circle>-->
      <!--      <circle cx="50%" cy="50%" r="6%" class="-active"></circle>-->
      <!--      <circle cx="50%" cy="50%" r="11%" class="-active"></circle>-->
      <!--      <circle cx="50%" cy="50%" r="16%" class="-active"></circle>-->
      <!--      <circle cx="50%" cy="50%" r="21%" class=""></circle>-->
      <!--      <circle cx="50%" cy="50%" r="26%" class=""></circle>-->
      <!--      <circle cx="50%" cy="50%" r="31%" class=""></circle>-->
      <!--      <circle cx="50%" cy="50%" r="36%" class=""></circle>-->
      <!--      <circle cx="50%" cy="50%" r="41%" class=""></circle>-->
      <!--      <circle cx="50%" cy="50%" r="46%" class=""></circle>-->
    </svg>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EnergyMeter',
  components: {},
  props: {
    dailyCalorieType: {
      type: Number,
      required: true,
    },
    calorieTypes: {
      type: Object,
      required: true,
    },
  },

  /* state */
  data() {
    return {}
  },

  /* computed */
  computed: {
    /**
     * Old browser may not return keys in a specific order, force order
     */
    calorieTypeKeys(): number[] {
      return Object.keys(this.calorieTypes)
        .map((key) => Number.parseInt(key))
        .sort((a, b) => a - b)
    },
  },

  /* lifecycle */

  /* component methods */
  methods: {},
})
</script>
